import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { isEmpty } from "utils";
import StateDropDown from "../Dropdowns/state";
import ZoneDropDown from "../Dropdowns/zone";
import DepartmentDropdown from "../Dropdowns/department";
import EmployeeTypeDropdown from "../Dropdowns/employeeType";
import BranchDropdown from "../Dropdowns/branch";
import DesignationDropdown from "../Dropdowns/Designation";
import DepartmentTypeDropDown from "../Dropdowns/departmentType";
import showPasswordIcon from "../../../images/show-password.svg";
import hidePasswordIcon from "../../../images/hide-password.svg";
import "./Form.css";
import LabDepartmentDropdown from "../Dropdowns/labDepartment";
import PackageDropDown from "../Dropdowns/packageDropDown";
import InvestigationDropdown from "../Dropdowns/investigation";
import ShareTypeDropdown from "../Dropdowns/shareType";
import EmployeeDropdown from "../Dropdowns/employee";
import OrganismDropdown from "../Dropdowns/organism";
import CityDropdown from "../Dropdowns/city";
import Franchise from "../Dropdowns/franchise";
import ObservationDropdown from "../Dropdowns/observation";
import FranchiseDropdown from "../Dropdowns/FranchiseDropdown";
import EmployeeCategory from "../Dropdowns/EmployeeCategory";
import CollectionType from "../Dropdowns/CollectionType";
import MultiSelectDropdown from "../Dropdowns/MultiSelectDropdown";
import MultiSelectInvestigationDropdown from "../Dropdowns/MultiSelectInvestigation";
import DoctorDegreeDropdown from "../Dropdowns/DoctorDegree";
import DoctorSpecializationDropdown from "../Dropdowns/DoctorSpecialization";
import AreaDropdown from "../Dropdowns/area";
import DoctorDropdown from "../Dropdowns/Doctor";
import CollectionTypeDropdown from "../Dropdowns/CollectionType";
import Select from "react-select";
import PaymentModeDropdown from "../Dropdowns/paymentMode";
import OutsourceLabDropdown from "../Dropdowns/outsourceLab";
import EmployeeAlreadyExists from "../Dropdowns/EmployeeAlreadyExists";
import DepartmentInvestigationDropdown from "../Dropdowns/departmentInvestigation";
import InvestigationObservationAlreadyExists from "../Dropdowns/InvestigationObservatiuonAlreadyExists";
import PaymentTypeDropdown from "../Dropdowns/paymentType";
import ChangeRateDropdown from "../Dropdowns/ChangeRateDropdown";
import SampleTypeDropdownNew from "../Dropdowns/SampleTypeDropdownNew";
import { showObservationRanges } from "../../../redux/action/observation_action";
import { useDispatch } from "react-redux";
import ObservationDropdownMultiSelector from "../Dropdowns/observationDropDownMultiSelector";
import InvestigationMultipleSelectorDropdown from "../Dropdowns/InvestigationMultipleSelector";
import axiosInstance from "services/axios";
import { EndPoints } from "settings/endpoints";
import RolesDropdownMultiSelector from "../Dropdowns/rolesDropDownMultiSelector";
import MachineMasterDropdown from "../Dropdowns/machineMasterDropDown";
import ReportRolesDropDown from "../Dropdowns/ReportRolesDropDown";
import ZoneDropdownMultiSelector from "../Dropdowns/ZoneMultiSelector";
import ReportRolesMultiSelectorDropDown from "../Dropdowns/ReportRolesMultiSelectorDropDown ";
import DoctorMultiSelector from "../Dropdowns/DoctorMultiSelector";
import TextEditor from "../TextEditor/editor";
import VendorDropDown from "../Dropdowns/Vendor";
import TermsConditionDropDown from "../Dropdowns/TermsCondition";
import PurchaseOrderDropDown from "../Dropdowns/PurchaseOrder";
import ProductDrop from "../Dropdowns/Product";
import DatePicker from "../DatePicker/datepicker";
import EmployeeLeaveDropdown from "../Dropdowns/EmployeeLeaveDropDown";
import EmployeeDropdownReportRole from "../Dropdowns/EmployeeDropDownReportRole";
import TimerPicker from "../DatePicker/timerpicker";
import TimerPickerCustom from "../DatePicker/timerpicker";
import FranchiseDropdownWithCode from "../Dropdowns/FranchiseDropdownWithCode";
import FranchiseDropdownWithLogged from "../Dropdowns/FranchiseDropdownWithLogged";
import FieldDatePicker from "../DatePicker/fieldDatePicker";
import ProductTypeDropdown from "../Dropdowns/ProductTypeDropdown";
import MachineDropdown from "../Dropdowns/MachineDropdown";
import UnitDropdown from "../Dropdowns/UnitDropdown";
import MembershipDropdown from "../Dropdowns/MembershipDropdown";
import InvestigationWiseObservationDropdown from "../Dropdowns/InvestigationWiseObservationDropdown";
import SectionDropdownMultiSelector from "../Dropdowns/sectionDropDownMultiSelector";
import MarketingPersonDropdown from "../Dropdowns/MarketingPersonDropdown";
import { STALE_TIME } from "utils/constants";
import { fetchZoneLogoById } from "services/zone";
import { useQuery } from "@tanstack/react-query";
import ClinicDropdown from "../Dropdowns/ClinicDropdown";

const CustomForm = ({
  config,
  onSubmit,
  columnCount = 2,
  rowData = {},
  isAdditional,
  formName = null,
  isRangeDataAvailable = false,
  mappedData = null,
  signatureData = false,
  uploadZoneLogo = false,
  onLogoUpload = null,
  existingLogo = null,
}) => {
  const dispatch = useDispatch();
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [logoFile, setLogoFile] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    watch,
    getValues,
  } = useForm({
    defaultValues: {
      cutoff_time: rowData?.cutoff_time || "14:00",
    },
  });

  const { data: zoneData } = useQuery(
    ["fetch-zone-logo-by-id", rowData?.zone_id],
    () => fetchZoneLogoById(rowData?.zone_id),
    {
      enabled: !!rowData?.file_path && !!rowData?.zone_id,
      staleTime: STALE_TIME,
      select: (res) => res || [],
      onSuccess: (res) => {
        console.log("Zone data fetched:", res);
      },
      onError: (err) => {
        console.error("Error fetching zone data:", err);
      },
    },
  );

  const displayLogo = rowData?.file_path ? zoneData?.data : existingLogo;

  const calculateDOBFromAge = (age) => {
    if (!age || age < 0) return "";
    const today = new Date();
    const year = today.getFullYear() - age;

    return (
      year +
      "-" +
      String(today.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(today.getDate()).padStart(2, "0")
    );
  };

  const calculateAgeFromDOB = (dob) => {
    if (!dob) return "";
    const birth = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }

    return age;
  };

  useEffect(() => {
    if (!watch("cutoff_time")) {
      setValue("cutoff_time", rowData?.cutoff_time || "14:00");
    }
  }, []);

  const leaveFromDate = watch("leave_from");

  const [showUpload, setShowUpload] = useState(false);
  const [fileRequired, setFileRequired] = useState(false);
  const isSuperFranchise = watch("is_super_franchise");
  const isSubFranchise = watch("sub_franchise");

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const fileName = file.name;
  //     const filePath = URL.createObjectURL(file);
  //     const reader = new FileReader();

  //     reader.onloadend = () => {
  //       const fileData = reader.result;
  //       setValue("fileName", fileName);
  //       setValue("filePath", filePath);
  //       setValue("fileData", fileData);
  //       setFileRequired(false);
  //     };

  //     reader.readAsDataURL(file);
  //   } else {
  //     setFileRequired(true);
  //   }
  // };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const allowedTypes = ["image/png", "image/jpeg"];
      if (!allowedTypes.includes(file.type)) {
        setFileRequired(true);
        setValue("fileName", "");
        setValue("filePath", "");
        setValue("fileData", "");
        alert("Only PNG and JPEG files are allowed.");
        return;
      }

      const fileName = file.name;
      const filePath = URL.createObjectURL(file);
      const reader = new FileReader();

      reader.onloadend = () => {
        const fileData = reader.result;
        setValue("fileName", fileName);
        setValue("filePath", filePath);
        setValue("fileData", fileData);
        setFileRequired(false);
      };

      reader.readAsDataURL(file);
    } else {
      setFileRequired(true);
    }
  };

  const handleLogoFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setLogoFile(file.name);
        if (onLogoUpload) {
          onLogoUpload(file.name, base64String);
        }
      };
      reader.readAsDataURL(file);
      setFileRequired(false);
    }
  };

  useEffect(() => {
    if (isSuperFranchise === "Yes") {
      setValue("sub_franchise", "No");
    }
  }, [isSuperFranchise, setValue]);

  useEffect(() => {
    if (isSubFranchise === "Yes") {
      setValue("is_super_franchise", "No");
    }
  }, [isSubFranchise, setValue]);

  const handleShowHidePassword = () => {
    setShowPassword(!showPassword);
  };

  const convertDateToISO = (dateString) => {
    if (!dateString) return "";
    if (dateString.includes("-") && dateString.split("-")[0].length === 4) {
      return dateString;
    }
    const [day, month, year] = dateString.split("-");
    if (!day || !month || !year) return "";
    return `${year}-${month}-${day}`;
  };

  const [usernameValue, setUsernameValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const handlePasswordChange = async (e) => {
    const password = e.target.value;
    setPasswordValue(password);
  };
  const handleUsernameChange = async (e) => {
    const username = e.target.value;
    setUsernameValue(username);
    const payload = { username };
    try {
      const response = await axiosInstance.get(
        EndPoints.Franchise.EXISTS_USERNAME,
        {
          params: payload,
        },
      );
      setApiResponse(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setApiResponse(null);
    }
  };

  // useEffect(() => {
  //   config.forEach((field) => {
  //     if (field.type === "input-date") {
  //       const defaultDate = convertDateToISO(field.defaultValue);
  //       if (defaultDate) {
  //         setValue(field.name, defaultDate);
  //       }
  //     }
  //   });
  // }, [config, setValue]);

  useEffect(() => {
    config.forEach((field) => {
      if (field.type === "input-date" || field.type === "input-date-dob") {
        const defaultDate = convertDateToISO(field.defaultValue);
        if (defaultDate) {
          setValue(field.name, defaultDate);
        }
      }
    });
  }, [config, setValue]);

  const getInput = (field) => {
    switch (field.type) {
      case "text-area":
        if (!field) {
          return null;
        }
        return (
          <div className="w-100">
            <Controller
              name={field.name}
              control={control}
              defaultValue={field.defaultValue || ""}
              render={({ field }) => (
                <TextEditor
                  editorValue={field.value}
                  height={200}
                  setEditorValue={field.onChange}
                />
              )}
            />
          </div>
        );
      case "input-text":
        return field.name === "username" ? (
          <>
            <div>
              <input
                type="text"
                className="form-control commonInput"
                {...register(field.name, {
                  required: field.validations?.required || !!passwordValue,
                  maxLength: field.validations?.maxLength,
                  pattern: field.validations?.regex,
                })}
                disabled={field?.disabled ? true : false}
                defaultValue={field.defaultValue}
                onChange={(e) => {
                  handleUsernameChange(e);
                }}
              />
            </div>
            {apiResponse?.available !== 1 &&
              apiResponse?.available !== undefined && (
                <div className="api-response text-danger mt-2">
                  <p>Already Username Exists</p>
                </div>
              )}
          </>
        ) : (
          // <div className="input-field">
          //   <input
          //     type="text"
          //     className="form-control commonInput"
          //     style={{ textTransform: field.capitalize ? "uppercase" : "none" }}
          //     {...register(field.name, {
          //       required: field.validations?.required,
          //       maxLength: field.validations?.maxLength,
          //       pattern: field.validations?.regex,
          //     })}
          //     defaultValue={field.defaultValue}
          //     // disabled = {field.name === 'investigation_name' && rowData?.investigation_name ? true : false}
          //   />
          // </div>
          <div className="input-field">
            <input
              type="text"
              className="form-control commonInput"
              style={{ textTransform: field.capitalize ? "uppercase" : "none" }}
              {...register(field.name, {
                required: field.validations?.required,
                maxLength: field.validations?.maxLength,
                pattern: field.validations?.regex,
              })}
              defaultValue={field.defaultValue}
              placeholder={field.name === "mobile" ? "+919876543210" : ""}
            />
            {errors[field.name]?.type === "pattern" &&
              field.name === "mobile" && (
                <span className="text-danger">
                  Mobile number must be 10 digits, optional +91 or 0 prefix
                </span>
              )}
          </div>
        );
      case "input-text-age":
        return (
          <div className="input-field">
            <input
              type="text"
              className="form-control commonInput"
              {...register(field.name)}
              defaultValue={field.defaultValue}
              onChange={(e) => {
                const value = e.target.value;
                setValue(field.name, value);

                if (field.calculates === "dob") {
                  const dob = calculateDOBFromAge(Number(value));
                  setValue("dob", dob);
                }
              }}
            />
          </div>
        );
      case "input-multi-text":
        return (
          <div className="input-field">
            <input
              type="text"
              className="form-control commonInput"
              {...register(field.name, {
                required: field.validations?.required,
                maxLength: field.validations?.maxLength,
                pattern: field.validations?.regex,
              })}
              defaultValue={field.defaultValue}
            />
          </div>
        );
      case "input-number":
        return (
          // <div className="input-field">
          //   <input
          //     type="number"
          //     className="form-control commonInput"
          //     {...register(field.name, {
          //       required: field.validations?.required,
          //       maxLength: field.validations?.maxLength,
          //       pattern: {
          //         value: /^[0-9]+$/,
          //         message: "Only numbers are allowed",
          //       },
          //     })}
          //     defaultValue={field.defaultValue}
          //   />
          // </div>
          <div className="input-field">
            <input
              type="number"
              className="form-control commonInput"
              {...register(field.name, {
                required: field.validations?.required,
                maxLength: field.validations?.maxLength,
                validate: (value) => {
                  if (field.validations?.max && value > field.validations.max) {
                    return `Value cannot exceed ${field.validations.max}`;
                  }
                  return true;
                },
              })}
              defaultValue={field.defaultValue}
              disabled={field.readOnly || false}
              style={
                field.readOnly
                  ? { backgroundColor: "#e9ecef", cursor: "not-allowed" }
                  : {}
              }
              max={field.validations?.max}
              onInput={(e) => {
                if (
                  field.validations?.max &&
                  +e.target.value > field.validations.max
                ) {
                  e.target.value = field.validations.max;
                  alert(`Value cannot exceed ${field.validations.max}`);
                }
              }}
            />
          </div>
        );
      case "input-number-calculate":
        return (
          <div className="input-field">
            <input
              type="number"
              className="form-control commonInput"
              {...register(field.name, {
                required: field.validations?.required,
                maxLength: field.validations?.maxLength,
                validate: (value) => {
                  if (field.validations?.max && value > field.validations.max) {
                    return `Value cannot exceed ${field.validations.max}`;
                  }
                  return true;
                },
              })}
              defaultValue={field.defaultValue}
              max={field.validations?.max}
              onChange={(e) => {
                const receiveAmount = Number(e.target.value) || 0;
                const originalBalance = field.originalBalance || 0;

                if (receiveAmount > originalBalance) {
                  e.target.value = originalBalance;
                  alert(
                    `Receive amount cannot exceed balance amount (${originalBalance})`,
                  );
                  return;
                }

                const dueAmount = originalBalance - receiveAmount;

                if (field.calculateField) {
                  setValue(field.calculateField, dueAmount);
                }
              }}
            />
          </div>
        );
      case "input-number-percent":
        return (
          <div className="input-group d-flex input-field">
            <input
              type="number"
              className="form-control commonInput"
              {...register(field.name, {
                required: field.validations?.required,
                maxLength: field.validations?.maxLength,
                pattern: {
                  value: /^[0-9]+$/,
                  message: "Only numbers are allowed",
                },
              })}
              defaultValue={field.defaultValue}
            />
            <div className="input-group-append">
              <span
                className="input-group-text"
                style={{ height: "100%", borderRadius: "0 5px 5px 0" }}
              >
                %
              </span>
            </div>
          </div>
        );
      case "radio":
        return (
          <>
            {field.name === "default_sample_id" ? (
              <div>
                <div className="radio-group mt-4">
                  <Controller
                    name={"default_sample_id"}
                    control={control}
                    render={({ field }) => {
                      return getValues().sample_type_obj?.map(
                        (option, index) => {
                          return (
                            <div
                              className="form-check form-check-inline gap-1 input-field"
                              key={index}
                            >
                              <input
                                type="radio"
                                className="form-check-input commonInput"
                                {...register(field.name, {
                                  required: field.validations?.required,
                                })}
                                value={option.value ? option.value : option.id}
                                disabled={field.disabled}
                                onChange={(e) => {
                                  field.onChange(e.target.value);
                                  setValue("default_sample_id", e.target.value);
                                }}
                                defaultChecked={
                                  option.value === getValues().default_sample_id
                                }
                              />
                              <small className="form-check-label">
                                {option.value
                                  ? option.label
                                  : option.sample_type}
                              </small>
                            </div>
                          );
                        },
                      );
                    }}
                  />
                </div>
              </div>
            ) : (
              <>
                <div>
                  {field.options.map((option, index) => (
                    <div
                      className="form-check form-check-inline input-field"
                      key={index}
                    >
                      <input
                        type="radio"
                        className="form-check-input commonInput"
                        {...register(field.name, {
                          required: field.validations?.required,
                        })}
                        value={option.value}
                        disabled={field.disabled}
                        defaultChecked={field.defaultValue === option.value}
                      />
                      <label className="form-check-label">{option.label}</label>
                    </div>
                  ))}
                </div>
              </>
            )}
          </>
        );
      case "email":
        return (
          <div className="input-field">
            <input
              type="email"
              className="form-control commonInput"
              {...register(field.name, {
                required: field.validations?.required,
                maxLength: field.validations?.maxLength,
                pattern:
                  field.validations?.isEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              })}
              defaultValue={field.defaultValue}
              disabled={field.emailDisabled}
              title={field.hoverText}
            />
          </div>
        );
      case "select":
        if (field.name === "state") {
          return (
            <StateDropDown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "city") {
          return (
            <CityDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "franchise_dropdown") {
          return (
            <FranchiseDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              formKey={field.formKey}
              defaultValue={field?.defaultValue}
              required={field?.validations?.required}
              all_zone_franchise={field?.validations?.all_zone_franchise}
              copyRateMode={field?.copyRateMode}
              name_code={field.name_code}
              zone_wise={field?.zone_wise}
              loginUser={field?.loginUser}
            />
          );
        } else if (field.name === "franchise_dropdown_with_logged") {
          return (
            <FranchiseDropdownWithLogged
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              formKey={field.formKey}
              defaultValue={field?.defaultValue}
              required={field?.validations?.required}
              all_zone_franchise={field?.validations?.all_zone_franchise}
              copyRateMode={field?.copyRateMode}
              logged_in_franchise={field?.logged_in_franchise}
            />
          );
        } else if (field.name === "franchise_dropdown_with_franchise_code") {
          return (
            <FranchiseDropdownWithCode
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              formKey={field.formKey}
              defaultValue={field?.defaultValue}
              required={field?.validations?.required}
              all_zone_franchise={field?.validations?.all_zone_franchise}
              copyRateMode={field?.copyRateMode}
            />
          );
        } else if (field.name === "zone_id") {
          return (
            <ZoneDropDown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
              allZone={field?.allZone || false}
              allOption={field?.allOption || false}
              selectedZone={field?.selectedZone}
            />
          );
        } else if (field.name === "terms_and_condition_id") {
          return (
            <TermsConditionDropDown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "vendor_id") {
          return (
            <VendorDropDown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "product_id") {
          return (
            <ProductDrop
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "membership_id") {
          return (
            <MembershipDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
              defaultValue={field.defaultValue}
            />
          );
        } else if (field.name === "marketing_person_id") {
          return (
            <MarketingPersonDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
              defaultValue={field.defaultValue}
              employeeType={field.employeeType}
            />
          );
        } else if (field.name === "purchase_order_id") {
          return (
            <PurchaseOrderDropDown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "department") {
          return (
            <DepartmentDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "employee_type_id") {
          return (
            <EmployeeTypeDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
              defaultValue={field.defaultValue}
            />
          );
        } else if (field.name === "branch") {
          return (
            <BranchDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "designation") {
          return (
            <DesignationDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "franchise") {
          return (
            <FranchiseDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              formKey={field.formKey}
              defaultValue={field.defaultValue}
              copyRateMode={field.copyRateMode}
              isDisable={field.isDisable}
              name_code={field.name_code}
            />
          );
        } else if (field.name === "employee_category") {
          return (
            <EmployeeCategory
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              formKey={field.formKey}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "collection_type") {
          return (
            <CollectionType
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              formKey={field.formKey}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "department_type") {
          return (
            <DepartmentTypeDropDown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              name="department_type"
            />
          );
        } else if (field.name === "lab_department") {
          return (
            <LabDepartmentDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
              disabled={field.disabled}
            />
          );
        } else if (field.name === "investigation_name") {
          return (
            <InvestigationDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "department_investigation_name") {
          return (
            <DepartmentInvestigationDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              disabled={field.disabled}
            />
          );
        } else if (field.name === "investigation_name") {
          return (
            <InvestigationDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "investigation_id") {
          return (
            <InvestigationMultipleSelectorDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "outsource_lab") {
          return (
            <OutsourceLabDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "share_type") {
          return (
            <ShareTypeDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "employee_name") {
          return (
            <EmployeeDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              zoneId={field.zoneId}
              defaultValue={field.defaultValue}
            />
          );
        } else if (field.name === "employee_name_report_role") {
          return (
            <EmployeeDropdownReportRole
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "employee_leave") {
          return (
            <EmployeeLeaveDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "organism_name") {
          return (
            <OrganismDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "franchise_type") {
          return (
            <Franchise
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
              defaultValue={field?.defaultValue}
            />
          );
        } else if (field.name === "package_id") {
          return (
            <PackageDropDown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "multiinvestigation") {
          return (
            <MultiSelectInvestigationDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              field={field}
            />
          );
        } else if (field.name === "change_rate") {
          return (
            <ChangeRateDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.multi) {
          return (
            <MultiSelectDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              field={field}
            />
          );
        } else if (field.name === "observation_name") {
          return (
            <ObservationDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              defaultValue={field.defaultValue}
              rowData={rowData}
              mappedData={mappedData}
            />
          );
        } else if (field.name === "observation_id") {
          return (
            <InvestigationWiseObservationDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              defaultValue={field.defaultValue}
              rowData={rowData}
              mappedData={mappedData}
            />
          );
        } else if (field.name === "multi_observation_name") {
          return (
            <ObservationDropdownMultiSelector
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              defaultValue={field.defaultValue}
              rowData={rowData}
              mappedData={mappedData}
            />
          );
        } else if (field.name === "multi_roles") {
          return (
            <RolesDropdownMultiSelector
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              defaultValue={field.defaultValue}
              rowData={rowData}
              mappedData={mappedData}
            />
          );
        } else if (field.name === "multi_sections") {
          return (
            <SectionDropdownMultiSelector
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              defaultValue={field.defaultValue}
              rowData={rowData}
              mappedData={mappedData}
            />
          );
        } else if (field.name === "degree_name") {
          return (
            <DoctorDegreeDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "specialization_name") {
          return (
            <DoctorSpecializationDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "area") {
          return (
            <AreaDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "refer_doctor_name") {
          return (
            <DoctorDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              required={field?.validations?.required}
              defaultValue={field?.defaultValue}
            />
          );
        } else if (field.name === "clinic_id") {
          return (
            <ClinicDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              required={field?.validations?.required}
              defaultValue={field?.defaultValue}
            />
          );
        } else if (field.name === "unit_id") {
          return (
            <UnitDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              getValues={getValues}
              watch={watch}
              rowData={rowData}
              required={field.validations?.required}
              addUnit={field.addUnit}
              onAddUnitClick={field.onAddUnitClick}
            />
          );
        } else if (field.name === "multi_refer_doctor_name") {
          return (
            <DoctorMultiSelector
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "collection_type") {
          return (
            <CollectionTypeDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "payment_mode_id") {
          return (
            <PaymentModeDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
              online_mode={field?.online_mode}
              defaultValue={field?.defaultValue}
            />
          );
        } else if (field.name === "payment_type") {
          return (
            <PaymentTypeDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "sample_type_obj") {
          return (
            <SampleTypeDropdownNew
              control={control}
              defaultValue={rowData?.investigation_sample_type_obj || []}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
            />
          );
        } else if (field.name === "already_exists") {
          return (
            <EmployeeAlreadyExists
              control={control}
              defaultValue={rowData || []}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
            />
          );
        } else if (field.name === "investigation_observation_exists") {
          return (
            <InvestigationObservationAlreadyExists
              control={control}
              defaultValue={field.defaultValue || []}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
            />
          );
        } else if (field.name === "machine_name") {
          return (
            <MachineMasterDropdown
              control={control}
              defaultValue={field.defaultValue || []}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
            />
          );
        } else if (field.name === "machine_id") {
          return (
            <MachineDropdown
              control={control}
              defaultValue={field.defaultValue || []}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
            />
          );
        } else if (field.name === "role_name") {
          return (
            <ReportRolesDropDown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "product_type") {
          return (
            <ProductTypeDropdown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "multi_role_name") {
          return (
            <ReportRolesMultiSelectorDropDown
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              required={field?.validations?.required}
            />
          );
        } else if (field.name === "multiple_zone") {
          return (
            <ZoneDropdownMultiSelector
              control={control}
              errors={errors}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              rowData={rowData}
              field={field}
              mappedData={mappedData}
              defaultValue={field.defaultValue}
              allZone={field.allZone}
            />
          );
        } else {
          return (
            <div className="input-field">
              <select
                className="form-control commonInput"
                {...register(field?.name, {
                  required: field?.validations?.required,
                })}
                disabled={field?.disabled}
                defaultValue={field?.defaultValue}
              >
                {field?.options.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          );
        }
      case "input-select-multiple":
        return (
          <>
            <div className="input-field">
              <Controller
                control={control}
                rules={{
                  required: field.validations?.required
                    ? "This Field is required"
                    : false,
                }}
                name={field.name}
                defaultValue={field.defaultValue || []}
                render={({ field: { onChange, onBlur, value, name } }) => (
                  <Select
                    closeMenuOnSelect={false}
                    isMulti
                    isDisabled={field.disabled}
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions
                        ? selectedOptions.map((option) => option.value)
                        : [];
                      onChange(selectedValues);
                    }}
                    options={field.options}
                    className="basic-multi-select commonInput"
                    classNamePrefix="select"
                    name={name}
                    value={
                      field.options.filter((option) =>
                        value?.includes(option.value),
                      ) || []
                    }
                  />
                )}
              />
            </div>
          </>
        );
      case "input-password":
        return (
          <div className="password-field input-field">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control commonInput"
              {...register(field.name, {
                required: field.validations?.required || !!usernameValue,
                maxLength: field.validations?.maxLength,
                pattern: field.validations?.regex,
              })}
              disabled={field.disabled}
              defaultValue={field.defaultValue}
              onChange={(e) => {
                handlePasswordChange(e);
              }}
            />
            <span
              className="show-hide-password"
              onClick={handleShowHidePassword}
            >
              <img
                src={showPassword ? hidePasswordIcon : showPasswordIcon}
                alt={`${showPassword ? "Show" : "Hide"} Password`}
              />
            </span>
          </div>
        );
      // case "input-date": {
      //   const defaultDate = convertDateToISO(field.defaultValue);
      //   return (
      //     <div className="input-field">
      //       <input
      //         type="date"
      //         className="form-control commonInput"
      //         required={field.validations?.required}
      //         defaultValue={defaultDate ? defaultDate : ""}
      //         onChange={(e) => setValue(field.name, e.target.value)}
      //       />
      //     </div>
      //   );
      // }
      case "input-date": {
        return (
          <div className="input-field">
            <FieldDatePicker
              name={field.name}
              placeholder="Select a date"
              value={watch(field.name) || null}
              onChange={(date) => setValue(field.name, date)}
              disabled={field.disabled}
            />
            {field.name === "leave_to" &&
              leaveFromDate &&
              watch("leave_to") < leaveFromDate && (
                <p style={{ color: "red", fontSize: "12px" }}>
                  Leave To date should not be less than Leave From
                </p>
              )}
          </div>
        );
      }
      case "input-date-dob": {
        const dateValue = watch(field.name);
        const parsedDate = dateValue
          ? typeof dateValue === "string"
            ? new Date(dateValue)
            : dateValue
          : null;

        return (
          <div className="input-field">
            <FieldDatePicker
              name={field.name}
              placeholder="Select a date"
              value={parsedDate}
              onChange={(date) => {
                setValue(field.name, date);

                if (field.calculates === "age") {
                  const age = calculateAgeFromDOB(date);
                  setValue("age", age);
                }
              }}
              disabled={field.disabled}
            />
          </div>
        );
      }
      case "cutoff_time":
        return (
          <div className="input-field">
            <TimerPickerCustom
              value={watch("cutoff_time")}
              onChange={(value) => setValue("cutoff_time", value)}
            />
          </div>
        );

      case "input-time":
        return (
          <div className="input-field">
            <input
              type="time"
              className="form-control commonInput"
              {...register(field.name, {
                required: field.validations?.required,
                maxLength: field.validations?.maxLength,
                pattern: field.validations?.regex,
              })}
              defaultValue={field.defaultValue}
            />
          </div>
        );
      case "checkbox":
        return (
          <div className="form-check input-field">
            <input
              type="checkbox"
              className="form-check-input commonInput"
              {...register(field.name, {
                required: field.validations?.required,
                maxLength: field.validations?.maxLength,
                pattern: field.validations?.regex,
              })}
              defaultChecked={field.defaultValue}
              onChange={(e) => {
                setValue(field.name, e.target.checked);
              }}
            />
          </div>
        );
      default:
        return null;
    }
  };

  const handleAdditionalInfo = () => {
    setShowAdditionalInfo(!showAdditionalInfo);
  };

  const htmlTextAreaFieldList = [
    "header_info",
    "sample_type_obj",
    "default_sample_id",
    "remark",
    "template_description",
    "investigation_id",
    "multiple_zone",
    "terms_and_condition",
    "notes",
  ];

  const handleRangeForm = () => {
    dispatch(showObservationRanges(true));
  };

  useEffect(() => {
    if (rowData && rowData.length > 0) {
      reset(rowData);
    }
  }, [rowData, reset]);

  const [isSignatureUploaded, setIsSignatureUploaded] = useState(false);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="addInformationForm">
      {!isAdditional ? (
        <div className="row">
          {config?.map((field, index) =>
            !field.hidden || !field.hidden(rowData) ? (
              <div
                className={`col-md-${
                  htmlTextAreaFieldList.includes(field.name) ||
                  (field.name === "comments" && field.type === "text-area")
                    ? "12"
                    : 12 / columnCount
                } mb-3`}
                key={`${field.name}-${index}`}
                style={{ alignContent: "center" }}
              >
                <div
                  className={
                    field.type === "checkbox"
                      ? "d-flex align-items-center mt-4 p-0 m-0"
                      : ""
                  }
                >
                  {field?.type === "checkbox" && Array.isArray(field.name) ? (
                    field.name.map((checkboxName, idx) => (
                      <div
                        key={`${checkboxName}-${idx}`}
                        className="form-check d-flex flex-row"
                      >
                        {getInput({ ...field, name: checkboxName })}
                        <small
                          className="form-check-label text-nowrap"
                          htmlFor={checkboxName}
                        >
                          {field.label[idx]}
                        </small>
                      </div>
                    ))
                  ) : (
                    <>
                      <label className="mb-2 me-2">{field.label}</label>
                      {getInput(field)}
                    </>
                  )}
                </div>

                {errors[field?.name] && (
                  <span className="text-danger">
                    {errors[field.name]?.message || "This field is required"}
                  </span>
                )}

                {field.name === "doctor_type" && field.type === "select" && (
                  <>
                    {watch("doctor_type") === "INTERNAL" && (
                      <div className="mt-2">
                        {!isSignatureUploaded ? (
                          <button
                            type="button"
                            className="btn btn-primary mt-2"
                            onClick={() => {
                              setShowUpload(true);
                              setIsSignatureUploaded(true);
                            }}
                          >
                            {field.defaultValue !== "INTERNAL"
                              ? "Upload Signature"
                              : "Edit Signature"}
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-warning mt-2"
                            onClick={() => {
                              setShowUpload(false);
                              setIsSignatureUploaded(false);
                            }}
                          >
                            Unupload Signature
                          </button>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            ) : null,
          )}
        </div>
      ) : (
        <>
          <div className="row mb-4">
            {config.map((field, index) =>
              !field.hidden || !field.hidden(rowData) ? (
                showAdditionalInfo ||
                (index < isAdditional &&
                  (!(
                    // field.name === "username" ||
                    (field.name === "password" || field.name === "password_md5")
                  ) ||
                    !field.disabled)) ? (
                  <div
                    className={`col-md-${12 / columnCount} mb-3`}
                    key={`${field.name}-${index}`}
                  >
                    <label className="mb-2">{field.label}</label>
                    {getInput(field)}
                    {field.name === "doctor_type" &&
                      field.type === "select" && (
                        <>
                          {watch("doctor_type") === "INTERNAL" && (
                            <div className="mt-2">
                              {!isSignatureUploaded ? (
                                <button
                                  type="button"
                                  className="btn btn-primary mt-2"
                                  onClick={() => {
                                    setShowUpload(true);
                                    setIsSignatureUploaded(true);
                                  }}
                                >
                                  {field.defaultValue !== "INTERNAL"
                                    ? "Upload Signature"
                                    : "Edit Signature"}
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-warning mt-2"
                                  onClick={() => {
                                    setShowUpload(false);
                                    setIsSignatureUploaded(false);
                                  }}
                                >
                                  Unupload Signature
                                </button>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    {errors[field.name] && (
                      <span className="text-danger">
                        {errors[field.name]?.message ||
                          "This field is required"}
                      </span>
                    )}
                  </div>
                ) : null
              ) : null,
            )}
          </div>

          <div className="additional-info-section">
            <b onClick={handleAdditionalInfo}>
              Additional Information {showAdditionalInfo ? "-" : "+"}
            </b>
          </div>
        </>
      )}
      {uploadZoneLogo && (
        <div className="row mt-3">
          <div className="col-8">
            <label className="mb-2 me-2">Upload Zone Logo</label>
            <div className="form-group">
              <input
                type="file"
                accept="image/*"
                className={`form-control`}
                id="logoUpload"
                onChange={handleLogoFileChange}
              />
            </div>
            {rowData?.file_path && (
              <div className="mt-2">
                <small className="text-muted">
                  Current file: {rowData.file_path}
                </small>
              </div>
            )}
          </div>
          {displayLogo && rowData?.zone_id && (
            <div className="col-4 d-flex justify-content-end align-items-center">
              <img
                src={`data:image/${
                  displayLogo.startsWith("iVBOR") ? "png" : "jpeg"
                };base64,${displayLogo}`}
                alt="Zone Logo"
                style={{ maxHeight: "80px", width: "auto" }}
              />
            </div>
          )}
        </div>
      )}
      <div className="row">
        {showUpload && watch("doctor_type") === "INTERNAL" ? (
          <div className="col-8">
            <label className="mb-2 me-2">Upload Signature</label>
            <div className="form-group">
              <input
                type="file"
                required
                className={`form-control ${fileRequired ? "is-invalid" : ""}`}
                id="fileUpload"
                onChange={handleFileChange}
              />
              {fileRequired && (
                <div className="invalid-feedback">File is required</div>
              )}
            </div>
          </div>
        ) : (
          <div className="col-8"></div>
        )}

        {/* {signatureData && rowData?.doctor_id && (
          <div className="col-4 d-flex justify-content-end">
            <img
              src={`data:image/png;base64,${signatureData}`}
              alt="Signature"
              style={{ width: "150px", height: "auto" }}
            />
          </div>
        )} */}
        {signatureData && rowData?.id && (
          <div className="col-4 d-flex justify-content-end w-100">
            <img
              src={`data:image/${
                signatureData.startsWith("iVBOR") ? "png" : "jpeg"
              };base64,${signatureData}`}
              alt="Signature"
              style={{ height: "auto" }}
            />
          </div>
        )}
      </div>

      {formName === "addComment" ? (
        <div className="d-flex justify-content-end mt-4">
          <button type="submit" className="btn mt-4 btn-danger">
            Confirm Reject
          </button>
        </div>
      ) : formName !== "addObservationForm" ? (
        <button
          type="submit"
          className="btn btn-primary mt-4"
          disabled={
            apiResponse?.available !== 1 &&
            apiResponse?.available !== undefined &&
            isEmpty(rowData)
          }
        >
          {isEmpty(rowData) ? "Add" : "Update"}
        </button>
      ) : (
        <>
          <button
            type="button"
            className="btn btn-primary mt-4"
            onClick={handleRangeForm}
          >
            Add Range
          </button>
          <button
            type="submit"
            className="btn btn-primary mt-4 ml-3"
            disabled={isRangeDataAvailable}
          >
            {isEmpty(rowData) ? "Submit" : "Update"}
          </button>
        </>
      )}
    </form>
  );
};

export default CustomForm;
